import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-center" }

import LoginForm from '@/components/LoginForm.vue'
import RegistrationForm from '@/components/RegistrationForm.vue'
import RegistrationConfirmForm from '@/components/RegistrationConfirmForm.vue'
import { ref } from 'vue'

type AuthPageMode = 'login' | 'register'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizationView',
  setup(__props) {

const mode = ref<AuthPageMode>(window.location.search.includes('ref=') ? 'register' : 'login')
const email = ref<string>('')

const handleVerified = () => {
  mode.value = 'login'
  email.value = ''
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (mode.value === 'register')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (email.value)
          ? (_openBlock(), _createBlock(RegistrationConfirmForm, {
              key: 0,
              email: email.value,
              onVerified: handleVerified
            }, null, 8, ["email"]))
          : (_openBlock(), _createBlock(RegistrationForm, {
              key: 1,
              onCreate: _cache[0] || (_cache[0] = value => { email.value = value })
            })),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (mode.value = 'login'))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Вход")
            ]),
            _: 1
          })
        ])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(LoginForm),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (mode.value = 'register'))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Регистрация")
            ]),
            _: 1
          })
        ])
      ], 64))
}
}

})